export default function genererCritereRechercheProduitsSurRegroupementjs() {
  return {
    categorie: [],
    actif: true,
    references: [],
    libelles: [],
    avecLiaisons: null,
    societeId: null,
    agencesId: [],
  };
}
